(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('uko-header-countdown')) {
    customElements.define('uko-header-countdown', class extends HTMLElement {
      connectedCallback() {
        this.releaseAt = Date.parse(this.dataset.releaseAt);
        this.clock = this.querySelector('[data-countdown-clock]');
        this.fallback = this.querySelector('[data-countdown-fallback]');
        this.ended = this.querySelector('[data-countdown-ended]');
        this.fields = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-countdown-' + unit + ']'));
        if (!Number.isFinite(this.releaseAt) || !this.clock || !this.fallback || !this.ended || this.fields.some(field => !field)) return;
        this.refresh = () => this.updateClock();
        this.timer = window.setInterval(this.refresh, 1000);
        this.refresh();
        document.addEventListener('visibilitychange', this.refresh);
      }
      updateClock() {
        const total = Math.max(0, Math.ceil((this.releaseAt - Date.now()) / 1000));
        this.fallback.hidden = true;
        this.clock.hidden = total === 0;
        this.ended.hidden = total !== 0;
        if (total === 0) {
          window.clearInterval(this.timer);
          return;
        }
        const values = [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
        this.fields.forEach((field, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (field.textContent !== value) field.textContent = value;
        });
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
      }
    });
  }
if (!customElements.get('uko-header-music')) {
  const controls = new Set();
  let audio = null;
  let source = '';
  let wanted = false;
  let playing = false;
  let loading = false;
  let failed = false;
  let request = 0;
  const render = () => controls.forEach(control => control.render());
  const stop = (error = false) => {
    request += 1; wanted = false; playing = false; loading = false; failed = error;
    if (audio) audio.pause();
    render();
  };
  const reconcile = () => {
    if (!controls.size || (source && !Array.from(controls).some(control => control.musicSource === source))) stop();
  };
  const createAudio = () => {
    if (audio) return audio;
    audio = new Audio(); audio.preload = 'none'; audio.loop = true;
    audio.addEventListener('playing', () => {
      if (!wanted || !controls.size) { stop(); return; }
      if (audio.paused || audio.ended) return;
      playing = true; loading = false; failed = false; render();
    });
    audio.addEventListener('waiting', () => {
      if (!wanted || audio.paused) return;
      playing = false; loading = true; render();
    });
    audio.addEventListener('pause', () => {
      if (!audio.paused) return;
      request += 1; wanted = false; playing = false; loading = false; render();
    });
    audio.addEventListener('ended', () => { if (audio.ended) stop(); });
    audio.addEventListener('error', () => { if (audio.error) stop(true); });
    return audio;
  };
  const start = control => {
    if (!control.musicSource) return;
    let currentRequest;
    try {
      const player = createAudio();
      if (source !== control.musicSource || player.error) {
        player.pause(); source = control.musicSource; player.src = source;
      }
      const volume = control.dataset.volume === undefined || control.dataset.volume.trim() === '' ? 35 : Number(control.dataset.volume);
      player.volume = Math.min(100, Math.max(0, Number.isFinite(volume) ? volume : 35)) / 100;
      wanted = true; playing = false; loading = true; failed = false; currentRequest = ++request; render();
      const started = player.play();
      Promise.resolve(started).then(() => {
        if (currentRequest !== request) { if (!wanted) player.pause(); return; }
        if (!wanted || !controls.size) { stop(); return; }
        playing = !player.paused && !player.ended; loading = false; wanted = playing; render();
      }).catch(() => { if (currentRequest === request && wanted) stop(true); });
    } catch { stop(true); }
  };
  customElements.define('uko-header-music', class extends HTMLElement {
    static get observedAttributes() { return ['data-src', 'data-volume', 'data-on', 'data-off', 'data-loading', 'data-error']; }
    get musicSource() { return (this.dataset.src || '').trim(); }
    connectedCallback() {
      if (controls.has(this)) return;
      this.button = this.querySelector('[data-music-toggle]');
      this.label = this.querySelector('[data-music-label]');
      this.status = this.querySelector('[data-music-status]');
      if (!this.button || !this.label) return;
      this.button.type = 'button';
      this.toggle = () => { if (wanted || playing) stop(); else start(this); };
      this.button.addEventListener('click', this.toggle); this.button.hidden = false;
      controls.add(this); this.render(); queueMicrotask(reconcile);
    }
    disconnectedCallback() {
      if (this.button && this.toggle) this.button.removeEventListener('click', this.toggle);
      controls.delete(this); queueMicrotask(reconcile);
    }
    attributeChangedCallback(name) {
      if (!controls.has(this)) return;
      this.render(); if (name === 'data-src') queueMicrotask(reconcile);
    }
    render() {
      if (!this.button || !this.label) return;
      const available = Boolean(this.musicSource);
      const active = available && playing;
      const pending = available && loading;
      const error = available && failed;
      this.dataset.state = !available ? 'unavailable' : error ? 'error' : pending ? 'loading' : active ? 'playing' : 'off';
      this.button.disabled = !available;
      this.button.setAttribute('aria-pressed', String(active));
      this.button.setAttribute('aria-busy', String(pending));
      this.label.textContent = pending ? this.dataset.loading || 'Loading…' : active ? this.dataset.off || 'Sound off' : this.dataset.on || 'Sound on';
      if (this.status) this.status.textContent = error ? this.dataset.error || 'Music could not load. Tap Sound on to retry.' : '';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uko-password-drop')){
  customElements.define('uko-password-drop',class extends HTMLElement{
    connectedCallback(){
      this.deadline=Date.parse(this.dataset.launchAt);
      if(!Number.isFinite(this.deadline))return;
      this.clock=this.querySelector('[data-drop-clock]');
      this.status=this.querySelector('[data-drop-status]');
      this.updateClock();
      if(this.deadline>Date.now())this.timer=setInterval(()=>this.updateClock(),1000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
    updateClock(){
      const remaining=Math.max(0,Math.ceil((this.deadline-Date.now())/1000));
      if(remaining===0){
        clearInterval(this.timer);
        this.clock.hidden=true;
        this.status.textContent=this.dataset.expiredText;
        this.status.hidden=false;
        return;
      }
      this.clock.hidden=false;
      const units={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
      for(const [key,value] of Object.entries(units))this.querySelector('[data-unit="'+key+'"]').textContent=String(value).padStart(2,'0');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uko-accessories-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uko-accessories-tabs')){
customElements.define('uko-accessories-tabs',class extends HTMLElement{
connectedCallback(){this.initializationFrame=requestAnimationFrame(()=>this.initialize())}
disconnectedCallback(){cancelAnimationFrame(this.initializationFrame);this.events?.abort()}
initialize(){
if(!this.isConnected)return;
this.events?.abort();this.events=new AbortController();
const options={signal:this.events.signal};
const tablist=this.querySelector('.uko-accessories__tabs');
const tabs=[...this.querySelectorAll('.uko-accessories__tab')];
const panels=[...this.querySelectorAll('.uko-accessories__panel')];
if(!tablist||!tabs.length||tabs.length!==panels.length)return;
const select=(index,moveFocus=false)=>{
tabs.forEach((tab,tabIndex)=>{
const selected=tabIndex===index;const panel=panels[tabIndex];
tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;
panel.hidden=!selected;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tab.id);panel.tabIndex=0;
if(selected){const products=panel.querySelector('.uko-accessories__products');if(products)products.scrollLeft=0}
});if(moveFocus)tabs[index].focus();
};
tabs.forEach((tab,index)=>{
tab.addEventListener('click',()=>select(index),options);
tab.addEventListener('keydown',(event)=>{
let nextIndex;const rtl=getComputedStyle(tablist).direction==='rtl';
if(event.key==='ArrowRight')nextIndex=(index+(rtl?-1:1)+tabs.length)%tabs.length;
if(event.key==='ArrowLeft')nextIndex=(index+(rtl?1:-1)+tabs.length)%tabs.length;
if(event.key==='Home')nextIndex=0;
if(event.key==='End')nextIndex=tabs.length-1;
if(nextIndex===undefined)return;event.preventDefault();select(nextIndex,true);
},options);
});
const selectedIndex=tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true');
select(Math.max(selectedIndex,0));this.setAttribute('data-ready','');tablist.hidden=false;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uko-character-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uko-character-showcase')) {
customElements.define('uko-character-showcase', class extends HTMLElement {
connectedCallback(){
if(this.controller)return;
this.controller=new AbortController();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>this.initialize(),{once:true,signal:this.controller.signal});
else this.initialize();
}
disconnectedCallback(){
this.controller?.abort();clearTimeout(this.railTimer);clearTimeout(this.resizeTimer);cancelAnimationFrame(this.rebaseFrame);cancelAnimationFrame(this.turnFrame);this.profileAnimation?.cancel();
this.querySelectorAll('[data-loop-clone]').forEach(card=>card.remove());
this.controller=null;this.pointerDown=false;this.pointerStart=null;this.targetCard=null;this.rebasing=false;
}
initialize(){
if(!this.isConnected||!this.controller)return;
this.querySelectorAll('[data-loop-clone]').forEach(card=>card.remove());
this.slides=Array.from(this.querySelectorAll('[data-character-slide]'));
this.selectors=Array.from(this.querySelectorAll('[data-character-select]'));
if(!this.slides.length)return;
const signal=this.controller.signal;
this.status=this.querySelector('[data-character-status]');this.counter=this.querySelector('[data-character-counter]');
this.previous=this.querySelector('[data-character-previous]');this.next=this.querySelector('[data-character-next]');this.rail=this.querySelector('[data-character-selectors]');
this.motionPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
this.targetCard=null;this.pointerDown=false;this.rebasing=false;
if(this.rail&&this.selectors.length>1){
const before=document.createDocumentFragment();const after=document.createDocumentFragment();
this.selectors.forEach(card=>{before.append(this.cloneCard(card,'before'));after.append(this.cloneCard(card,'after'));});
this.rail.prepend(before);this.rail.append(after);
}
this.cards=Array.from(this.rail?.querySelectorAll('[data-character-select]')||this.selectors);
this.flipCards=this.cards.map(card=>({card,surface:card.querySelector('.uko-card__surface')})).filter(item=>item.surface);
this.classList.add('is-enhanced');
this.querySelectorAll('[data-character-navigation],[data-character-selectors]').forEach(control=>{control.hidden=this.slides.length<2;});
this.show(Number.isInteger(this.currentIndex)?this.currentIndex:0,false,true,false);
this.rail?.addEventListener('scroll',()=>{this.queueCardTurns();if(this.rebasing)return;clearTimeout(this.railTimer);this.railTimer=setTimeout(()=>this.settle(),190);},{signal,passive:true});
this.rail?.addEventListener('scrollend',()=>this.settle(),{signal,passive:true});
this.rail?.addEventListener('pointerdown',()=>{this.pointerDown=true;this.targetCard=null;},{signal,passive:true});
const release=()=>{if(!this.pointerDown)return;this.pointerDown=false;clearTimeout(this.railTimer);this.railTimer=setTimeout(()=>this.settle(),190);};
window.addEventListener('pointerup',release,{signal,passive:true});window.addEventListener('pointercancel',release,{signal,passive:true});
this.rail?.addEventListener('wheel',event=>{if(Math.abs(event.deltaX)>Math.abs(event.deltaY)||event.shiftKey)this.targetCard=null;},{signal,passive:true});
this.rail?.addEventListener('focusin',event=>{const card=event.target.closest('[data-loop-clone]');if(card)this.selectors[this.logicalIndex(card)]?.focus({preventScroll:true});},{signal});
this.addEventListener('click',event=>{
const button=event.target.closest('button');if(!button||!this.contains(button))return;
if(button.hasAttribute('data-character-previous'))this.step(-1);
else if(button.hasAttribute('data-character-next'))this.step(1);
else if(button.hasAttribute('data-character-select')){this.show(this.logicalIndex(button),true,true,true,0,button);if(button.hasAttribute('data-loop-clone'))this.selectors[this.logicalIndex(button)]?.focus({preventScroll:true});}
},{signal});
this.addEventListener('keydown',event=>{
if(event.altKey||event.ctrlKey||event.metaKey||event.shiftKey||this.slides.length<2)return;
if(event.target.closest('input,textarea,select,summary,a,[contenteditable="true"]'))return;
if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
event.preventDefault();
if(event.key==='ArrowLeft')this.step(-1);else if(event.key==='ArrowRight')this.step(1);else this.show(event.key==='Home'?0:this.slides.length-1);
if(event.target.closest('[data-character-select]'))this.selectors[this.targetCard?this.logicalIndex(this.targetCard):this.currentIndex]?.focus({preventScroll:true});
},{signal});
this.addEventListener('pointerdown',event=>{if(event.pointerType==='mouse'||!event.target.closest('[data-character-visual]')||this.slides.length<2)return;this.pointerStart={x:event.clientX,y:event.clientY,time:performance.now(),id:event.pointerId};},{signal,passive:true});
this.addEventListener('pointerup',event=>{const start=this.pointerStart;this.pointerStart=null;if(!start||start.id!==event.pointerId)return;const dx=event.clientX-start.x;const dy=event.clientY-start.y;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5&&performance.now()-start.time<900)this.step(dx<0?1:-1);},{signal,passive:true});
this.addEventListener('pointercancel',()=>{this.pointerStart=null;},{signal,passive:true});
this.motionPreference.addEventListener('change',()=>{if(this.motionPreference.matches){this.profileAnimation?.cancel();this.show(this.targetCard?this.logicalIndex(this.targetCard):this.currentIndex,false,true,false);}this.renderCardTurns();},{signal});
window.addEventListener('resize',()=>{clearTimeout(this.resizeTimer);this.resizeTimer=setTimeout(()=>this.show(this.targetCard?this.logicalIndex(this.targetCard):this.currentIndex,false,true,false),150);},{signal,passive:true});
document.addEventListener('shopify:block:select',event=>{const index=this.slides.findIndex(slide=>slide.dataset.characterBlock===event.detail?.blockId);if(index<0)return;this.show(index,false,true,false);this.slides[index].scrollIntoView({block:'nearest',behavior:'instant'});},{signal});
}
queueCardTurns(){
if(this.turnFrame)return;this.turnFrame=requestAnimationFrame(()=>{this.turnFrame=null;this.renderCardTurns();});
}
renderCardTurns(){
if(!this.rail||!this.flipCards)return;
const bounds=this.rail.getBoundingClientRect();const center=bounds.left+bounds.width/2;const reduced=this.motionPreference.matches;
const gap=parseFloat(getComputedStyle(this.rail).columnGap)||0;const compact=window.matchMedia('(max-width:749px)').matches;const angle=compact?24:32;const scaleDrop=compact?.04:.09;
const positions=this.flipCards.map(item=>{const rect=item.card.getBoundingClientRect();const distance=(rect.left+rect.width/2-center)/(rect.width+gap);const progress=Math.max(-1.15,Math.min(1.15,distance));const amount=Math.min(1,Math.abs(progress));return {...item,visible:rect.right>bounds.left&&rect.left<bounds.right,turn:reduced?'0deg':(-progress*angle).toFixed(2)+'deg',scale:reduced?'1':(1-amount*scaleDrop).toFixed(4),opacity:reduced?'1':(1-amount*.18).toFixed(4)};});
positions.forEach(item=>{const style=item.surface.style;if(style.getPropertyValue('--card-turn')!==item.turn)style.setProperty('--card-turn',item.turn);if(style.getPropertyValue('--card-scale')!==item.scale)style.setProperty('--card-scale',item.scale);if(style.getPropertyValue('--card-opacity')!==item.opacity)style.setProperty('--card-opacity',item.opacity);item.surface.classList.toggle('is-turning',item.visible&&!reduced);});
}
cloneCard(card,side){
const clone=card.cloneNode(true);clone.dataset.loopClone=side;clone.setAttribute('aria-hidden','true');clone.tabIndex=-1;clone.removeAttribute('autofocus');
const ids=new Map();const nodes=[clone,...clone.querySelectorAll('*')];
nodes.forEach(node=>{if(node.id){const old=node.id;const next=old+'-loop-'+side;ids.set(old,next);node.id=next;}});
nodes.forEach(node=>{for(const attribute of Array.from(node.attributes)){let value=attribute.value;ids.forEach((next,old)=>{value=value.split('url(#'+old+')').join('url(#'+next+')');if(value==='#'+old)value='#'+next;});if(value!==attribute.value)node.setAttribute(attribute.name,value);}});
clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node=>node.tabIndex=-1);
return clone;
}
wrap(index){return((index%this.slides.length)+this.slides.length)%this.slides.length;}
logicalIndex(card){return this.wrap(Number(card.dataset.characterSelect));}
cardPosition(card){const rect=card.getBoundingClientRect();return Math.max(0,Math.min(this.rail.scrollWidth-this.rail.clientWidth,this.rail.scrollLeft+rect.left+rect.width/2-this.rail.getBoundingClientRect().left-this.rail.clientWidth/2));}
nearestCard(){const center=this.rail.getBoundingClientRect().left+this.rail.clientWidth/2;let nearest=this.cards[0],distance=Infinity;this.cards.forEach(card=>{const rect=card.getBoundingClientRect();const delta=Math.abs(rect.left+rect.width/2-center);if(delta<distance){distance=delta;nearest=card;}});return nearest;}
jumpTo(left){
this.rebasing=true;cancelAnimationFrame(this.rebaseFrame);const behavior=this.rail.style.scrollBehavior;this.rail.style.scrollBehavior='auto';this.rail.scrollTo({left,behavior:'instant'});this.rail.style.scrollBehavior=behavior;this.renderCardTurns();
this.lastSettledLeft=left;this.rebaseFrame=requestAnimationFrame(()=>{this.rebasing=false;});
}
rebase(card){if(!card?.hasAttribute('data-loop-clone')||this.pointerDown)return card;const original=this.selectors[this.logicalIndex(card)];this.jumpTo(this.rail.scrollLeft+this.cardPosition(original)-this.cardPosition(card));return original;}
updateNavigation(){const disabled=this.slides.length<2;if(this.previous)this.previous.disabled=disabled;if(this.next)this.next.disabled=disabled;}
step(delta){
if(this.slides.length<2||!this.rail)return;
let base=this.targetCard||this.nearestCard();let position=this.cards.indexOf(base);let card=this.cards[position+delta];
if(!card){base=this.rebase(base);position=this.cards.indexOf(base);card=this.cards[position+delta];}
if(card)this.show(this.logicalIndex(card),true,true,true,delta,card);
}
show(index,announce=true,centerCard=true,animate=true,direction=0,requestedCard=null){
if(!this.slides?.length)return;index=this.wrap(index);clearTimeout(this.railTimer);
if(!centerCard||!this.rail||!this.selectors[index]){this.targetCard=null;this.select(index,announce,animate,direction);return;}
let card=requestedCard;
if(!card){if(!animate)card=this.selectors[index];else{const base=this.targetCard?this.cardPosition(this.targetCard):this.rail.scrollLeft;card=this.cards.filter(item=>this.logicalIndex(item)===index).reduce((best,item)=>Math.abs(this.cardPosition(item)-base)<Math.abs(this.cardPosition(best)-base)?item:best);}}
const left=this.cardPosition(card);direction=direction||Math.sign(left-this.rail.scrollLeft);
if(!animate||this.motionPreference.matches||Math.abs(this.rail.scrollLeft-left)<2){this.targetCard=null;this.jumpTo(left);this.select(index,announce,animate,direction);this.rebase(card);return;}
this.targetCard=card;this.pendingAnnouncement=announce;this.pendingDirection=direction;this.movementDeadline=performance.now()+2000;
this.rail.scrollTo({left,behavior:'smooth'});this.railTimer=setTimeout(()=>this.settle(),190);
}
settle(){
clearTimeout(this.railTimer);if(!this.isConnected||!this.rail||this.pointerDown||this.rebasing)return;
if(this.targetCard&&Math.abs(this.rail.scrollLeft-this.cardPosition(this.targetCard))>2&&performance.now()<this.movementDeadline){this.railTimer=setTimeout(()=>this.settle(),100);return;}
const card=this.nearestCard();const announce=this.targetCard?this.pendingAnnouncement:true;const direction=this.targetCard?this.pendingDirection:Math.sign(this.rail.scrollLeft-(this.lastSettledLeft??this.rail.scrollLeft));
this.targetCard=null;this.select(this.logicalIndex(card),announce,true,direction);this.lastSettledLeft=this.rail.scrollLeft;this.rebase(card);
}
select(index,announce=true,animate=true,direction=0){
const previousIndex=this.currentIndex;const changed=previousIndex!==index;this.currentIndex=index;
this.slides.forEach((slide,slideIndex)=>{const active=slideIndex===index;slide.hidden=!active;slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));});
this.cards.forEach(button=>button.setAttribute('aria-pressed',String(this.logicalIndex(button)===index)));this.updateNavigation();
if(this.counter)this.counter.textContent=String(index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
if(!changed)return;this.profileAnimation?.cancel();
if(animate&&!this.motionPreference.matches){const panel=this.slides[index].querySelector('.uko-characters__dossier')||this.slides[index];direction=direction||Math.sign(index-previousIndex)||1;this.profileAnimation=panel.animate([{opacity:0,transform:'translateX('+direction*18+'px)'},{opacity:1,transform:'translateX(0)'}],{duration:280,easing:'cubic-bezier(.22,.61,.36,1)'});}
if(announce&&this.status)this.status.textContent=this.dataset.announcement.replace('__NUMBER__',String(index+1)).replace('__TOTAL__',String(this.slides.length)).replace('__NAME__',this.slides[index].dataset.characterName);
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uko-cosplay-program"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uko-cosplay')) { customElements.define('uko-cosplay', class extends HTMLElement { connectedCallback() { if (this.dataset.ready) return; this.dataset.ready = 'true';
const carousel = this.querySelector('.characters');
const characterSlides = Array.from(carousel.querySelectorAll('.character-slide'));
const characterButtons = Array.from(carousel.querySelectorAll('[data-character-select]'));
let characterIndex = 0;
const showCharacter = (index, focusButton = false) => {
  characterIndex = (index + characterSlides.length) % characterSlides.length;
  characterSlides.forEach((slide, i) => { slide.hidden = i !== characterIndex; });
  characterButtons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === characterIndex)));
  this.querySelector('.character-count').textContent = `${String(characterIndex + 1).padStart(2, '0')} / ${String(characterSlides.length).padStart(2, '0')}`;
  this.querySelector('.character-status').textContent = this.dataset.announcement.replace('__NUMBER__', characterIndex + 1).replace('__TOTAL__', characterSlides.length).replace('__NAME__', characterSlides[characterIndex].dataset.characterName);
  const selected = characterButtons[characterIndex];
  const strip = selected.parentElement;
  const buttonRect = selected.getBoundingClientRect();
  const stripRect = strip.getBoundingClientRect();
  if (buttonRect.left < stripRect.left || buttonRect.right > stripRect.right) {
    strip.scrollLeft += buttonRect.left - stripRect.left - (strip.clientWidth - selected.offsetWidth) / 2;
  }
  if (focusButton) selected.focus({ preventScroll: true });
}
characterButtons.forEach((button, index) => {
  button.addEventListener('click', () => showCharacter(index));
  button.addEventListener('keydown', (event) => {
    const destinations = { ArrowRight: characterIndex + 1, ArrowLeft: characterIndex - 1, Home: 0, End: characterSlides.length - 1 };
    if (!(event.key in destinations)) return;
    event.preventDefault();
    showCharacter(destinations[event.key], true);
  });
});
this.querySelector('[data-previous]').addEventListener('click', () => showCharacter(characterIndex - 1));
this.querySelector('[data-next]').addEventListener('click', () => showCharacter(characterIndex + 1));
let swipeStart = null;
carousel.querySelectorAll('.character-visual').forEach(visual => {
  visual.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') swipeStart = { x: event.clientX, y: event.clientY }; });
  visual.addEventListener('pointerup', event => {
    if (!swipeStart) return;
    const dx = event.clientX - swipeStart.x;
    const dy = event.clientY - swipeStart.y;
    swipeStart = null;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) showCharacter(characterIndex + (dx < 0 ? 1 : -1));
  });
  visual.addEventListener('pointercancel', () => { swipeStart = null; });
});

this.addEventListener('shopify:block:select', event => { const index = characterSlides.findIndex(slide => slide.contains(event.target)); if(index >= 0) showCharacter(index); });
} }); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uko-drop-preview"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('uko-drop-preview')){
customElements.define('uko-drop-preview',class extends HTMLElement{
connectedCallback(){
this.target=Date.parse(this.dataset.release||'');this.counter=this.querySelector('[data-countdown]');this.staticDate=this.querySelector('[data-static-date]');this.expired=this.querySelector('[data-expired]');this.invalid=this.querySelector('[data-invalid]');
this.parts=['days','hours','minutes','seconds'].map(part=>this.querySelector('[data-'+part+']'));this.update=this.update.bind(this);this.update();if(Number.isFinite(this.target)&&this.target>Date.now())this.timer=window.setInterval(this.update,1000);
}
disconnectedCallback(){window.clearInterval(this.timer)}
update(){
if(!Number.isFinite(this.target)){this.counter.hidden=true;this.staticDate.hidden=true;this.invalid.hidden=false;return}
const remaining=Math.max(0,Math.ceil((this.target-Date.now())/1000));this.staticDate.hidden=true;this.invalid.hidden=true;this.counter.hidden=remaining===0;this.expired.hidden=remaining!==0;
if(remaining===0){window.clearInterval(this.timer);return}
const values=[Math.floor(remaining/86400),Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60];this.parts.forEach((part,index)=>{part.textContent=String(values[index]).padStart(2,'0')});
}
});}
(() => {
  const guard = '__ukoDropEmailSignupTrackingV1';
  if (window[guard] || window.Shopify?.designMode || !document.querySelector('uko-drop-preview')) return;
  window[guard] = true;

  const forms = [
    { selector: '[data-forms-id="forms-root-1166689"] shopify-forms-embed', id: '1166689' },
    { selector: 'shopify-forms-embed#app-embed-container-1164600', id: '1164600' }
  ];
  const selector = forms.map(form => form.selector).join(', ');
  const formIdFor = host => forms.find(form => host.matches(form.selector))?.id;
  const lifetime = 5 * 60 * 1000;
  const bindings = new Map();
  const accepted = new Map();
  let discoveryTimer = null;
  let deliveryTimer = null;

  const createId = () => {
    try {
      if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID();
    } catch {}
    try {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    } catch {
      return null;
    }
  };

  const deliver = () => {
    if (deliveryTimer !== null) clearTimeout(deliveryTimer);
    deliveryTimer = null;
    for (const [id, attempt] of accepted) {
      if (Date.now() >= attempt.expiresAt || window.Shopify?.designMode || !document.querySelector('uko-drop-preview')) {
        accepted.delete(id);
        continue;
      }
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish !== 'function') continue;
      accepted.delete(id);
      try {
        const result = analytics.publish('uko_drop_email_signup_completed', {
          form_id: attempt.formId,
          signup_id: id,
          version: 1
        });
        if (typeof result?.catch === 'function') result.catch(() => {});
      } catch {}
    }
    if (accepted.size) deliveryTimer = setTimeout(deliver, 250);
  };

  const bind = (host, root) => {
    const formId = formIdFor(host);
    const readStep = () => root.querySelector('[data-current-step]')?.getAttribute('data-current-step') || '';
    let previousStep = readStep();
    let pending = null;
    const active = () => host.isConnected && formId && formIdFor(host) === formId &&
      document.querySelector('uko-drop-preview') && !window.Shopify?.designMode;

    const onSubmit = event => {
      if (!event.target?.matches?.('form[data-testid="form"]')) return;
      pending = null;
      if (!active() || readStep() !== 'form') return;
      previousStep = 'form';
      const consent = event.target.querySelector('input[name="emailConsent"]#emailConsent-true');
      if (consent?.checked !== true) return;
      const id = createId();
      if (id) pending = { id, formId, expiresAt: Date.now() + lifetime };
    };

    const observer = new MutationObserver(() => {
      if (!active()) {
        pending = null;
        return;
      }
      const step = readStep();
      if (!step) return;
      const completed = previousStep === 'form' && step === 'success';
      previousStep = step;
      if (!completed) return;
      const attempt = pending;
      pending = null;
      if (!attempt || Date.now() >= attempt.expiresAt) return;
      accepted.set(attempt.id, attempt);
      deliver();
    });

    root.addEventListener('submit', onSubmit, true);
    observer.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-current-step']
    });
    bindings.set(host, {
      root,
      disconnect() {
        pending = null;
        observer.disconnect();
        root.removeEventListener('submit', onSubmit, true);
      }
    });
  };

  const scheduleDiscovery = (delay = 0) => {
    if (discoveryTimer !== null) return;
    discoveryTimer = setTimeout(() => {
      discoveryTimer = null;
      discover();
    }, delay);
  };

  const discover = () => {
    const hosts = new Set(document.querySelector('uko-drop-preview') && !window.Shopify?.designMode
      ? document.querySelectorAll(selector)
      : []);
    for (const [host, binding] of bindings) {
      if (!hosts.has(host) || host.shadowRoot !== binding.root) {
        binding.disconnect();
        bindings.delete(host);
      }
    }
    let waitingForRoot = false;
    for (const host of hosts) {
      if (bindings.has(host)) continue;
      if (host.shadowRoot) bind(host, host.shadowRoot);
      else waitingForRoot = true;
    }
    if (waitingForRoot) scheduleDiscovery(250);
  };

  const discoveryObserver = new MutationObserver(() => scheduleDiscovery());
  discoveryObserver.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-forms-id', 'id']
  });
  discover();
})();


  } catch(e) { console.error(e); }
})();
})();
